import { Component } from '@angular/core';
import { AbstractFieldComponent } from '../abstract-field.component';

@Component( {
    selector: 'erp-pbw-namen',
    templateUrl: './input-field.component.html'
} )
export class SurnameComponent extends AbstractFieldComponent<string> {

    constructor() {
        super( 'rm.erp.jobapplication.JobApplication.surname' );
    }

    set value( t: string | undefined ) {
        if ( this.jobapplication != null ) {
            this.jobapplication.surname = t;
        }
    }

    get value(): string | undefined {
        return this.jobapplication?.surname;
    }
}
